import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, PageEvent } from '@angular/material';
import { HttpService } from '../http.service';
import { TimeService } from '../time.service';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { SnackbarService } from '../snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-debit-notes',
  templateUrl: './debit-notes.component.html',
  styleUrls: ['./debit-notes.component.scss']
})
export class DebitNotesComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  displayColumns = ['credit_note_no', 'amount', 'tax_amount', 'final_amount'];
  debitNotesList: MatTableDataSource<any>;

  totalAdvices = 0;
  symbol: any;

  invoiceFilters: any = {
    type:'Debit',
    skip: 0,
    limit: 5,
  };
  date_filter: any = {
    from_date: Date,
    to_date: Date,
  };
  showLoader = false;
  carrierId:Subscription

  constructor(private http: HttpService, private translation:TranslateService,private events:EventService ,private snackbar:SnackbarService,private timeService: TimeService) { }

  ngOnInit() {
    this.setTime();
    this.fetchDebitNotes(this.invoiceFilters);
    const rupee = JSON.parse(localStorage.getItem('carriers'));
    this.symbol = rupee[0].country.currency.symbol;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.fetchDebitNotes();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }
  // set the time in the date picker
  setTime() {
    this.date_filter.from_date = ( d => new Date(d.setDate(d.getDate() - 30)) )(new Date); // sets the from date to 30 days before date
    this.date_filter.from_date.setHours(0, 0, 0, 0); // set hours to 12:00AM
    this.date_filter.to_date = new Date(); // set the to_date to today's date
    this.date_filter.to_date.setHours(23, 59, 59, 0);
    this.invoiceFilters.from = this.timeService.toUTCEpoch(this.date_filter.from_date);
    this.invoiceFilters.to = this.timeService.toUTCEpoch(this.date_filter.to_date);
    this.date_filter.min = this.date_filter.from_date;
    this.date_filter.max = this.date_filter.to_date;
  }

  pageNavigate(event: PageEvent) {
    this.invoiceFilters.limit = event.pageSize;
    this.invoiceFilters.skip = event.pageIndex * event.pageSize;
    this.fetchDebitNotes(this.invoiceFilters);
  }

  // set the from_date when selected from the date picker
  setFromDateTime(value) {
    this.date_filter.from_date = value.from_date;
    const t1 = DateTime.fromJSDate(value.from_date).toFormat('dd/MM/yyyy 00:00:00');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy 00:00:00'); // get the epoch time
    this.invoiceFilters.from = epoch.ts;
    this.invoiceFilters.to = this.timeService.toUTCEpoch(this.date_filter.to_date);
    this.fetchDebitNotes(this.invoiceFilters);
    this.date_filter.min = this.date_filter.from_date;
  }

  // set to_date to the value set from the date picker
  setToDateTime(value) {
    this.date_filter.to_date = value.to_date;
    this.date_filter.to_date.setHours(23, 59, 59, 0);
    const t1 = DateTime.fromJSDate(value.to_date).toFormat('dd/MM/yyyy hh:mm:ss a');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy hh:mm:ss a');
    this.invoiceFilters.to = epoch.ts;
    this.invoiceFilters.from = this.timeService.toUTCEpoch(this.date_filter.from_date);
    this.fetchDebitNotes(this.invoiceFilters);
    this.date_filter.max = this.date_filter.to_date;
  }

  fetchDebitNotes(filter:any = {}) {
    this.showLoader = true;
    filter.limit =  this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
    this.http.get('carrier_note/get_all', filter, 1).subscribe(
      (response: any) => {
        this.showLoader = false;
        const data = response.data.notes.map(e => ({
          carrier_bills: e.carrier_bills,
          id:e._id,
          CNIN:e.CNIN.default,
          pdf_link:e.pdf_link,
          tax_amount:e.tax_amount,
          amount: e.pre_tax_amount,
          final_amount: e.final_amount
        }));

        if (!this.debitNotesList) {
          this.totalAdvices = response.data.count;
          this.debitNotesList = new MatTableDataSource(data);
          this.debitNotesList.sort = this.sort;
          this.debitNotesList.paginator = this.paginator;
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('DEBIT_NOTES.pagination_label');
        } else {
          this.totalAdvices = response.data.count;
          this.debitNotesList = new MatTableDataSource(data);
          this.paginator._intl.itemsPerPageLabel= this.translation.instant('DEBIT_NOTES.pagination_label');
        }
      },
      (err)=>{
        this.showLoader =false;
        this.snackbar.openSnackBar(err.error.message,'','err');
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('DEBIT_NOTES.pagination_label');
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

}
